import React from "react";
import Footer from "../../components/Footer/Footer";

const WorkAtStells = () => {
  return (
    <React.Fragment>
      <div className="stellco_employment__banner">
        <div className="stellco_orange__logo">
          <div className="stellco_orange__logo-white"></div>
        </div>

        <a href="/" className="stellco_homepage">
          Home
        </a>

        <a
          href="/stellco-job-application.pdf"
          download={true}
          className="stellco_employment__application orange"
        >
          Download Application
        </a>
      </div>

      <div className="stellco_employment__information">
        <div className="stellco_employment__content">
          <h2 className="stellco_employment__heading">Come Join Our Team!</h2>
          <div className="stellco_employment__details">
            Apply in person or bring in a{" "}
            <a href="/stellco-job-application.pdf" download={true}>
              printable application
            </a>{" "}
            and, or resume if you are interested in being a part of Stell's.
            Come into our Barton location at{" "}
            <a
              href="https://www.google.com/maps/place/1580+Barton+Rd,+Redlands,+CA+92373/@34.0475582,-117.2104482,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcaa3a050ce0db:0xfbac17c7d6f0a880!8m2!3d34.0475538!4d-117.2082595"
              target="_blank"
              rel="noreferrer"
            >
              1580 Barton Rd.
            </a>{" "}
            or our Ford location at{" "}
            <a
              href="https://www.google.com/maps/place/1453+Ford+St,+Redlands,+CA+92373/@34.0390612,-117.1582153,17z/data=!4m5!3m4!1s0x80db560ea70963e3:0x52a1bfd02c28ce22!8m2!3d34.0390568!4d-117.1560266"
              target="_blank"
              rel="noreferrer"
            >
              1453 Ford St. #103
            </a>{" "}
            and pick up an application.
          </div>

          <a
            href="/stellco-job-application.pdf"
            download={true}
            className="stellco_employment__application-orange"
          >
            Download Application
          </a>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default WorkAtStells;
